import React, { useState } from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Button, Card, Checkbox, Text } from '@/ui';

interface Question {
  question: string;
  options: [{ id: number; value: string }];
  correctAnswers: number[];
}

interface DynamicInstructionProps {
  question: Question;
  onContinue: () => void;
  onGoBack: () => void;
}

export default function DynamicQuestion({
  question,
  onContinue,
  onGoBack,
}: DynamicInstructionProps) {
  const { styles, theme } = useStyles(stylesheet);
  const [selectedAnswers, setSelectedAnswers] = useState<number[]>([]);
  const [showError, setShowError] = useState(false);
  const gaveCorrectAnswers =
    selectedAnswers.sort().toString() ===
    question.correctAnswers.sort().toString();

  return (
    <View style={styles.container}>
      <View style={{ gap: 24 }}>
        <View style={{ gap: 8 }}>
          <Text type="title1">Test Your Knowledge</Text>

          <Text
            type="bodyRegular"
            style={{ color: theme.colors.text.secondary }}
          >
            Select the actions below that would result in a violation of our
            policies and loss of your deposit.
          </Text>
        </View>

        <View style={{ gap: 8 }}>
          {question.options.map((option, index) => (
            <Card key={`option-${index}`}>
              <View
                style={{
                  padding: 16,
                  flexDirection: 'row',
                  gap: 8,
                  alignItems: 'center',
                }}
              >
                <Checkbox
                  active={selectedAnswers.includes(option.id)}
                  onPress={() => {
                    if (selectedAnswers.includes(option.id)) {
                      const filteredAnswers = selectedAnswers.filter(
                        (answer) => answer !== option.id
                      );

                      setSelectedAnswers(filteredAnswers);
                    } else {
                      setSelectedAnswers([...selectedAnswers, option.id]);
                    }

                    setShowError(false);
                  }}
                />

                <Text>{option.value}</Text>
              </View>
            </Card>
          ))}
        </View>

        {showError ? (
          <Text type="bodyRegular" style={{ color: theme.colors.error }}>
            Your answer is not correct. Please try again or read the information
            again.
          </Text>
        ) : null}
      </View>

      <View>
        <Button
          text="Next"
          type="primary"
          onPress={() => {
            if (gaveCorrectAnswers) {
              onContinue();
            } else {
              setShowError(true);
            }
          }}
          disabled={selectedAnswers.length === 0}
        />

        <Button text="Go Back" type="ghost" onPress={onGoBack} />
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flexGrow: 1,
    height: '100%',
    backgroundColor: theme.colors.background_1,
    justifyContent: 'space-between',
  },
}));
